import { playerRepository, teamRepository } from "../storage/storage";
import ValidationError from "./exceptions/validation-error";
import GamedayApiService from "./gameday-api-service";

class PlayerService {
    async getPlayers(teamId, filteredUniforms = [], includeDeleted = false) {
        return playerRepository
            .where({ teamId: teamId })
            .filter(
                (p) =>
                    !filteredUniforms.includes(p.uniform) &&
                    (includeDeleted || !p.deleted)
            )
            .toArray();
    }

    async savePlayer(player) {
        return GamedayApiService.saveOrUpdatePlayer(player);
    }

    async savePlayers(teamId, players) {
        if (players.some((p) => p.teamId !== teamId)) {
            throw new ValidationError("Invalid Team Id");
        }

        const team = await teamRepository.getById(teamId);
        await GamedayApiService.saveOrUpdatePlayers(team.teamId, players);

        return playerRepository.where({ teamId: teamId }).toArray();
    }

    async getPlayer(id) {
        return playerRepository.getById(id);
    }

    async deletePlayer(id) {
        return playerRepository.delete(id);
    }

    async deletePlayers(playerIds) {
        return playerRepository.bulkDelete(playerIds);
    }
}

export default new PlayerService();
